import { Component, OnInit } from '@angular/core';
import { AdminService } from '../admin/admin.service';

@Component({
  selector: 'app-atm-services',
  templateUrl: './atm-services.component.html',
  styleUrls: ['./atm-services.component.scss']
})
export class AtmServicesComponent implements OnInit {
  color;
  lastProjets = [];
  constructor(
    private adminService:AdminService
  ) { }

  ngOnInit() {
    this.lastProjets = this.adminService.getLastProjets();
  }

}
